export default "__VITE_ASSET__CQKg_pOD__"